import React from 'react';
import PropTypes from 'prop-types';

export const SvgMail = ({ width, height, stroke = '#000000' }) => (
  <svg width={width || '16px'} height={height || '14px'} viewBox="0 0 16 14" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g transform="translate(-211.000000, -478.000000)" stroke={stroke} strokeWidth="2">
        <g transform="translate(210.000000, 470.000000)">
          <g transform="translate(-3.000000, 3.000000)">
            <path d="M6.66666667,6.66666667 L17.3333333,6.66666667 C18.0666667,6.66666667 18.6666667,7.26666667 18.6666667,8 L18.6666667,16 C18.6666667,16.7333333 18.0666667,17.3333333 17.3333333,17.3333333 L6.66666667,17.3333333 C5.93333333,17.3333333 5.33333333,16.7333333 5.33333333,16 L5.33333333,8 C5.33333333,7.26666667 5.93333333,6.66666667 6.66666667,6.66666667 Z" />
            <polyline points="18.6666667 8 12 12.6666667 5.33333333 8" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgMail.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
